export const isInViewport = (element) => {
  const {top, bottom} = element.getBoundingClientRect();
  const viewPortHeight = (window.innerHeight || document.documentElement.clientHeight);

  return (
    (top > 0 || bottom > 0) &&
    top < viewPortHeight
  );
};
